import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchGroupings = createAsyncThunk(
    'user/fetchGroupings',
    async ({user}) => {
        try {
            const groupings = await fetchFun(`/api/v1/grouping?userId=${user?._id}`);
            if(groupings?.success) {
                return groupings.data
            }
        } catch(error) {
            console.log("Error - /checks", error)
        }
    }
);

export const fetchTbLibData = createAsyncThunk(
    'user/fetchTbLibData',
    async () => {
        try {
            const groupings = await fetchFun(`/api/v1/tbLib`);
            if(groupings?.success) {
                return groupings.data
            }
        } catch(error) {
            console.log("Error - /tbLibData", error)
        }
    }
);

export const fetchGrpLibUserData = createAsyncThunk(
    'user/fetchGrpLibUserData',
    async () => {
        try {
            const userGroupingLibData = await fetchFun(`/api/v1/tbGrpLibUser`);
            if(userGroupingLibData?.success) {
                return userGroupingLibData?.data
            }
        } catch (error) {
            console.log("Error - /tbGrpLibUser", error)
        }
    }
);

export const fetchGrpLibData = createAsyncThunk(
    //This API is specifically only for getting the original library without user specification.
    'user/fetchGrpLibData',
    async () => {
        try {
            const groupingLibData = await fetchFun(`/api/v1/tbGrpLib`);
            if(groupingLibData?.success) {
                return groupingLibData?.data
            }
        } catch (error) {
            console.log("Error - /tbGrpLibUser", error)
        }
    }
);